import React from 'react';
import { GuestDetail } from 'shared-types/Common';
import { GuestSelection } from './GuestSelection';
import {
  SpaDetailsRow,
  SpaDetailsCol,
  PackageItems,
  PackageItemsName,
} from './SpaPackageItems.styles';
import { some } from '@utils/some';

type SpaPackageItemsProps = {
  guestDetails?: Array<GuestDetail> | null;
  selectionGroups?: any;
  isBasketDrawer?: boolean;
};

export const SpaPackageItems: React.FC<SpaPackageItemsProps> = ({
  guestDetails,
  selectionGroups,
  isBasketDrawer,
}) => {
  const guestDetailsWithSelections: Array<GuestDetail & { selections: any }> = (
    guestDetails || []
  ).map((gd) => ({
    ...gd,
    selections: selectionGroups
      ?.filter((grp) => !grp.isExtras)
      .flatMap((grp) => grp.selections)
      .sort((a, b) => a.startTime?.localeCompare(b.startTime)),
    extras: selectionGroups?.filter((grp) => grp.isExtras).flatMap((grp) => grp.selections),
  }));
  return (
    <>
      {some(guestDetailsWithSelections) &&
        guestDetailsWithSelections.map(({ extras, selections, id }) => (
          <SpaDetailsRow key={id}>
            <SpaDetailsCol>
              {selections?.length > 0 && (
                <PackageItems isBasketDrawer={!!isBasketDrawer}>
                  {selections.map((selection) => {
                    return (
                      <>
                        <PackageItemsName>{selection.name}</PackageItemsName>
                      </>
                    );
                  })}
                </PackageItems>
              )}
              {extras?.length > 0 && <GuestSelection rows={extras} isExtra />}
              {selectionGroups?.map((group) =>
                group.isExtra ? (
                  <GuestSelection
                    rows={group.selections?.filter((sel) => sel.guestDetails.id === id)}
                    isExtra={group.isExtras}
                  />
                ) : (
                  <></>
                )
              )}
            </SpaDetailsCol>
          </SpaDetailsRow>
        ))}
    </>
  );
};
